import * as $ from 'jquery';
import 'slick-carousel';

class ProductCategoryCarousel {
  private ProductCategoryCarouselElements: NodeListOf<HTMLElement> = null;

  init = () => {
    this.ProductCategoryCarouselElements = document.querySelectorAll(
      '.js-card-carousel'
    );
    if (!this.ProductCategoryCarouselElements) {
      return;
    }

    this.bindListeners();
  };

  private bindListeners() {
    Array.prototype.map.call(this.ProductCategoryCarouselElements, (element) => {
      this.handleSlickInit(element);
    });
  }

  handleSlickInit(el: MouseEvent) {
    const sliderLoop = !$(el).hasClass('js-card-carousel--no-loop');
    
    let prevButton = null;
    let nextButton = null;

    // Dynamic cards
    if($(el).hasClass('dynamic-card__carousel__init')) {
      const $parentElement = $(el).parents(".dynamic-card__carousel");
      prevButton = $parentElement.find('.slider-controls').find('.slick-prev')
      nextButton = $parentElement.find('.slider-controls').find('.slick-next')
    } else {
      prevButton = $(el).siblings('.slider-controls').find('.slick-prev')
      nextButton = $(el).siblings('.slider-controls').find('.slick-next')
    }
    
    const $el = $(el);
    const slickSettings: JQuerySlickOptions = {
      dots: true,
      prevArrow: prevButton,
      nextArrow: nextButton,
      variableWidth: true,
      adaptiveHeight: true,
      infinite: sliderLoop,
      slidesToScroll: 1,
    };
    $el.slick(slickSettings);
    const totalSlides = $el.find('.slick-dots li').length;

    var $slideCount = $el.siblings('.slider-controls').find('.slider-controls__count');
    $slideCount.text(1 + '/' + totalSlides);
    //currentSlide is undefined on init -- set it to 1 in this case (currentSlide is 1 based)
    $el.on('afterChange', function (event, slick) {
      var currentSlide = slick.currentSlide + 1;
      $slideCount.text(currentSlide + '/' + totalSlides);
    });
  }
}

const ProductCategoryCarouselInstance = new ProductCategoryCarousel();
ProductCategoryCarouselInstance.init();
export { ProductCategoryCarousel, ProductCategoryCarouselInstance };
